import { defineStore } from 'pinia'

interface ThemeState {
  theme: string
}

interface ThemeActions {
  setSelectedTheme: (selectedTheme: string) => void
  getSelectedTheme: () => string
}

export const useThemeStore = defineStore<
  'theme',
  ThemeState,
  Record<string, any>,
  ThemeActions
>({
  id: 'theme',
  state: (): ThemeState => ({
    theme: 'dark',
  }),
  actions: {
    setSelectedTheme(selectedTheme: string) {
      this.theme = selectedTheme
    },
    getSelectedTheme(): string {
      return this.theme
    },
  },
})
